/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.makePayPalPayment.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * A paypal payment response
 */
@ExperimentalJsExport
@JsExport
@Serializable
data class PayPalPaymentModel(
    /** A paypal payment response data */
    @SerialName("data")
    val data: PayPalPayment?
) : Model()
